module.exports = __webpack_public_path__ + "static/media/pups-F3.7669097d.jpg";